import ResDetails from "./ResDetails";

export default ResDetails;
